import { render } from "./MissingRatesTooltip.vue?vue&type=template&id=2af0e970&ts=true"
import script from "./MissingRatesTooltip.vue?vue&type=script&lang=ts"
export * from "./MissingRatesTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__